import api from '@/API';
import { AppUser } from '@/type';
import appUserStorage from '@/auth/app-user-storage';

export function login(accessToken: string): Promise<AppUser> {
  return api
    .post('auth/login/access-token', { accessToken })
    .then((response) => {
      const appUser = (response.data.user as AppUser);
      appUserStorage.write(appUser);
      return appUser;
    });
}
